import React from 'react'
import { StyledBadge } from './styled'

const Badge = ({ variant, color, background, children, ...props }) => (
	<StyledBadge $variant={variant} $color={color} $background={background} {...props}>
		{children}
	</StyledBadge>
)

export default Badge
